module.exports = __webpack_public_path__ + "img/button-message.0dd1bcf4.svg";